// Set background image based on screen width
function setResponsiveBackground() {
  const heroElement = document.getElementById("hero-image");
  if (window.innerWidth <= 768) {
    // Mobile background (right image)
    heroElement.style.backgroundImage =
      "url('https://cdn.shopify.com/s/files/1/0654/4785/4134/files/mobileverison.webp?v=1743436311')";
  } else {
    // Desktop background (left image)
    heroElement.style.backgroundImage =
      "url('https://cdn.shopify.com/s/files/1/0654/4785/4134/files/explore.webp?v=1743436253')";
  }
}

// Initialize marquee duplication for seamless scrolling
function setupMarquee() {
  const marquee = document.getElementById("marquee");
  // Get all original items
  const originalItems = Array.from(marquee.children).slice(0, 5);

  // Clear existing items (including duplicates)
  marquee.innerHTML = "";

  // Create enough duplicates for smooth scrolling
  const totalSets = 4;
  for (let i = 0; i < totalSets; i++) {
    originalItems.forEach((item) => {
      marquee.appendChild(item.cloneNode(true));
    });
  }
}

// Call setup functions
window.addEventListener("load", () => {
  setResponsiveBackground();
  setupMarquee();
});

// Update background on window resize
window.addEventListener("resize", setResponsiveBackground);
